// src/Home.js
import React, { useState, useEffect } from 'react';
import { useUser } from './contexts/UserContext';
import { useTheme } from './contexts/ThemeContext';
import { useTranslation } from 'react-i18next';
import { Container, Button } from 'react-bootstrap';
import SEO from './components/SEO';
import TextToSpeech from './components/TextToSpeech';
import NewsletterDialog from './components/NewsletterDialog';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
// import { hasActiveSubscription } from './services/stripeService';
import './App.css';

const Home = () => {
  const { user, loading: userLoading } = useUser();
  const { theme } = useTheme();
  const { t } = useTranslation();
  const [showNewsletterDialog, setShowNewsletterDialog] = useState(false);
  // const [subscriptionActive, setSubscriptionActive] = useState(false);
  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   const checkSubscriptionStatus = async () => {
  //     // Only check subscription if user is authenticated
  //     if (user) {
  //       try {
  //         const hasActive = await hasActiveSubscription();
  //         setSubscriptionActive(hasActive);
  //       } catch (error) {
  //         console.error('Error checking subscription status:', error);
  //         setSubscriptionActive(false);
  //       }
  //     } else {
  //       // No user, so no subscription
  //       setSubscriptionActive(false);
  //     }
  //     setLoading(false);
  //   };

  //   // Wait for user context to finish loading before checking subscription
  //   if (!userLoading) {
  //     checkSubscriptionStatus();
  //   }
  // }, [user, userData, userLoading]);

  // Show loading state while user context is loading
  if (userLoading) {
    return (
      <div className="Home">
        <p>{t('common.loading')}</p>
      </div>
    );
  }

  const lightLogo = process.env.PUBLIC_URL + '/OsailuAndBoat.png';
  const darkLogo = process.env.PUBLIC_URL + '/osailu_and_boat_dark.png';
  const currentLogo = theme === 'dark' ? darkLogo : lightLogo;

  return (
    <>
      <SEO
        title="Osailu - Learn with the Future in Mind"
        description="Osailu helps you learn with the future in mind. Prepare for tomorrow's challenges with innovative learning tools and resources designed for forward-thinking learners."
        keywords="Osailu, future learning, education technology, innovative learning, forward-thinking education, learning tools, educational resources, EdTech"
        url="/"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": "Osailu",
          "applicationCategory": "EducationalApplication",
          "description": "Learn with the future in mind",
          "operatingSystem": "Web",
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "USD"
          },
          "publisher": {
            "@type": "Organization",
            "name": "Emerson Warwick Limited"
          }
        }}
      />
      <div className="Home">
        <div className="logo-container">
          <img
            src={currentLogo}
            alt="Osailu Logo"
            className="logo-image"
          />
        </div>
        <p>
          {user ? t('common.welcome') : t('common.welcomeTo')}
        </p>
        
        {/* <Container className="mt-5" style={{ maxWidth: '800px' }}>
          <TextToSpeech 
            text="Welcome to Osailu! This is a demonstration of our reusable text-to-speech component. You can listen to any text content using your browser's built-in speech synthesis. Try clicking the speaker icon in the top right corner to hear this message."
            rows={8}
          />
        </Container> */}
        
        {/* Newsletter Subscription Button for Testing */}
        <Container className="mt-4 text-center">
          <Button 
            variant="primary" 
            onClick={() => setShowNewsletterDialog(true)}
            size="lg"
          >
            {t('newsletter.subscribeTitle')}
          </Button>
        </Container>
      </div>
      <NewsletterDialog 
        show={showNewsletterDialog} 
        onHide={() => setShowNewsletterDialog(false)} 
      />
    </>
  );
};

const HomeWithRecaptcha = () => {
  const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  
  if (!recaptchaSiteKey) {
    console.warn('reCAPTCHA site key not configured');
    return <Home />;
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
      <Home />
    </GoogleReCaptchaProvider>
  );
};

export default HomeWithRecaptcha;
